import { gql } from '@apollo/client'

export const CREATE_IB_SINGLE_SIGN_ON_LINK = gql`
  mutation ($accountId: Int!, $ibId: String) {
    data: createIBSingleSignOnLink(accountId: $accountId, ibId: $ibId) {
      link
    }
  }
`
